import { OpArtBackground } from "@/components/main-page/OpArtBackground";
import { useTheme } from "@/hooks/useTheme";

export function LinkedInBannerPage() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div
      data-ready="true"
      style={{
        width: 1584,
        height: 396,
        background: isDark ? "#0a0a0a" : "#ffffff",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ position: "absolute", inset: 0, opacity: 0.7 }}>
        <OpArtBackground scrollProgress={0} />
      </div>

      <div style={{ position: "relative", zIndex: 10, textAlign: "center" }}>
        <img
          src={isDark ? "/logo-og.svg" : "/cosx-logo.svg"}
          alt="COSX"
          style={{ height: 48, marginBottom: 20 }}
        />
        <div
          style={{
            fontFamily: "var(--font-heading)",
            fontSize: 28,
            fontWeight: 300,
            letterSpacing: "-0.01em",
            color: isDark ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.7)",
          }}
        >
          AI agents for regulated industries
        </div>
      </div>
    </div>
  );
}
